import React from "react";
import { withRouter } from 'react-router-dom';
import { Button } from "semantic-ui-react";

let HomeButton = ({history}) => {
  
  return (
    <Button
      style={{ float: "left" }}
      onClick={() => history.push("/")}
      color="teal"
      icon="home"
    />
  );
};

export default withRouter(HomeButton);
